import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function DataDirectoryCta() {
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-697">
      <div className="bg-blue-600 rounded-[2.5rem] p-8 md:p-16 text-center relative overflow-hidden shadow-lg" data-id="element-698">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-699"></div>

        <div className="relative z-10 max-w-3xl mx-auto" data-id="element-700">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 tracking-tight leading-tight" data-id="element-701">
            Start browsing the local business database
          </h2>
          <p className="text-xl text-white/80 mb-10 leading-relaxed" data-id="element-702">
            Access comprehensive local business listings and verified business
            owner emails today.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-703">
            <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-8 py-4 bg-white text-blue-600 font-bold rounded-full hover:bg-blue-50 transition-colors text-lg w-full sm:w-auto justify-center shadow-sm" data-id="element-704">
              Try for free <ArrowRightIcon className="w-5 h-5" data-id="element-705" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}